
(function (window) {
  const testId = 'AB-026';
  const variantId = 'variant-1';

  waitFor(pageReady)
    .then(runVariant)
    .catch((err) => console.error(testId, err));

  function runVariant(root) {
    if (window.AB_026 === 1) return;

    window.AB_026 = 1;
    fetch(`${root}cart.js`)
      .then(resp => resp.json())
      .then(cart => {
        const itemsInCart = cart.items && cart.items.length;
        const freeItemInCart = cart.items && cart.items.some(item => item.id === 44480273088816);
   
        if (freeItemInCart) {
          showBanner();
        }

        if (itemsInCart && !freeItemInCart) {
          enableSwitch();
        }

        observeCart();
      })
      .catch((err) => console.error(testId, err));

    document.body.classList.add(testId);
    console.log(`${testId}: ${variantId}`);
  }


  function showBanner() {
    if (document.getElementById(`${testId}-banner`)) return;

    waitFor(() => document.querySelector('.upcart-products-section'), 20000)
      .then(prodsSection => {
        const html = `
        <div id="${testId}-banner">
          <img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/MagneticBandsBlackANGLE_x120.png?v=1710123117">
          <div class="${testId}-info">
            <div class="${testId}-heading">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.01305 15.7618L5.70254 10.6933C6.46856 8.39525 6.85156 7.24623 7.75782 7.03229C8.66408 6.81835 9.52051 7.67478 11.2334 9.38764L14.6124 12.7666C16.3252 14.4795 17.1817 15.3359 16.9677 16.2422C16.7538 17.1484 15.6048 17.5314 13.3067 18.2975L8.23822 19.987C5.47281 20.9088 4.0901 21.3697 3.36022 20.6398C2.63034 19.9099 3.09124 18.5272 4.01305 15.7618Z" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M12.2317 18.3462C12.2317 18.3462 11.4735 16.0651 11.4735 14.5554C11.4735 13.0456 12.2317 10.7645 12.2317 10.7645M8.06175 19.4835C8.06175 19.4835 7.42143 16.7316 7.30358 14.9345C7.10888 11.9652 8.06175 7.35272 8.06175 7.35272" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M14.5 10.0061L14.644 9.28614C14.7894 8.55924 15.3131 7.96597 16.0163 7.73155C16.7196 7.49714 17.2433 6.90387 17.3887 6.17697L17.5327 5.45703" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M17.5664 12.2536L17.7793 12.3765C18.4364 12.7558 19.2625 12.6722 19.8303 12.1688C20.3444 11.7129 21.0765 11.5973 21.7061 11.8725L21.9975 12" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M10.5299 3.00003C10.1924 3.55209 10.277 4.26347 10.7345 4.721L10.8324 4.81888C11.2255 5.21204 11.3705 5.78962 11.2096 6.32185" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M13.5649 4.39629C13.766 4.19524 13.8665 4.09471 13.9828 4.05786C14.0811 4.02669 14.1866 4.02669 14.2849 4.05786C14.4012 4.09471 14.5017 4.19524 14.7028 4.39629C14.9038 4.59735 15.0043 4.69788 15.0412 4.81412C15.0724 4.91243 15.0724 5.01798 15.0412 5.1163C15.0043 5.23254 14.9038 5.33307 14.7028 5.53412C14.5017 5.73518 14.4012 5.83571 14.2849 5.87256C14.1866 5.90372 14.0811 5.90372 13.9828 5.87256C13.8665 5.83571 13.766 5.73518 13.5649 5.53412C13.3639 5.33307 13.2633 5.23254 13.2265 5.1163C13.1953 5.01798 13.1953 4.91243 13.2265 4.81412C13.2633 4.69788 13.3639 4.59735 13.5649 4.39629Z" fill="#FF7900"/><path d="M19.4643 7.46822C19.7097 7.22283 19.8324 7.10014 19.9708 7.04681C20.1328 6.9844 20.3122 6.9844 20.4742 7.04681C20.6126 7.10014 20.7353 7.22283 20.9807 7.46822C21.2261 7.71362 21.3488 7.83631 21.4021 7.97473C21.4645 8.1367 21.4645 8.31609 21.4021 8.47807C21.3488 8.61649 21.2261 8.73918 20.9807 8.98457C20.7353 9.22996 20.6126 9.35266 20.4742 9.40599C20.3122 9.4684 20.1328 9.4684 19.9708 9.40599C19.8324 9.35266 19.7097 9.22996 19.4643 8.98457C19.2189 8.73918 19.0962 8.61649 19.0429 8.47807C18.9805 8.31609 18.9805 8.1367 19.0429 7.97473C19.0962 7.83631 19.2189 7.71362 19.4643 7.46822Z" fill="#FF7900"/><path d="M6.91882 3.94082C7.12829 3.73135 7.4679 3.73135 7.67737 3.94082C7.88684 4.15029 7.88684 4.48991 7.67737 4.69938C7.4679 4.90885 7.12829 4.90885 6.91882 4.69938C6.70935 4.48991 6.70935 4.15029 6.91882 3.94082Z" fill="#FF7900"/><path d="M19.0594 15.3134C19.2689 15.1039 19.6085 15.1039 19.818 15.3134C20.0275 15.5228 20.0275 15.8624 19.818 16.0719C19.6085 16.2814 19.2689 16.2814 19.0594 16.0719C18.85 15.8624 18.85 15.5228 19.0594 15.3134Z" fill="#FF7900"/><path d="M17.501 9.74148C17.7104 9.53201 18.0501 9.53201 18.2595 9.74148C18.469 9.95095 18.469 10.2906 18.2595 10.5C18.0501 10.7095 17.7104 10.7095 17.501 10.5C17.2915 10.2906 17.2915 9.95095 17.501 9.74148Z" fill="#FF7900"/></svg>
              <p>Congratulations!</p>
            </div>
            <p class="${testId}-name">QuickRelease™ Safety Strap</p>
            <div class="${testId}-sub"><p>FREE</p><p>&nbsp;gift valued at $20</p></div>
          </div>
        </div>`;

        prodsSection.insertAdjacentHTML('beforebegin', html);
      })
      .catch(err => console.error(testId, err));
  }

  // function observeCart() {                
  //   const config = {
  //     attributes: false,
  //     childList: true,
  //     subtree: true
  //   };

  //   const observer = new MutationObserver(mutations => {
  //     mutations.forEach(m => {
  //       const spContainerAdded = m.addedNodes && Array.from(m.addedNodes).some(el => el.nodeType === 1 && el.matches('.upcart-addons'));

  //       spContainerAdded && enableSwitch();

  //     });
  //   });
  
  //   waitFor(() => document.getElementById('upCart'))
  //     .then(upcartEl => observer.observe(upcartEl, config))
  //     .catch((err) => console.error(testId, err));
  // }


  function observeCart() {
    waitFor(() => window.upcartOnCartUpdated, 2000)
      .then(() => {
        const observer = new MutationObserver((mutations) => {
        
          enableSwitch();
        });
  
       
        const cartElement = document.getElementById('upCart');
        if (cartElement) {
          observer.observe(cartElement, { childList: true, subtree: true });
        }
      });
  }
  


  // function enableSwitch() {
  //   waitFor(() => document.querySelector('#UpcartPopup .upcart-addons-toggle > div'), 20000)
  //     .then(el => {
  //       const disabled = Array.from(el.classList).some(cls => cls.includes('active'));

  //       !disabled && el.click();
  //       showBanner();
  //     });
  // }
  function enableSwitch() {
    waitFor(() => document.querySelector('#UpcartPopup .upcart-addons-toggle > div'), 20000)
      .then(el => {
        const disabled = Array.from(el.classList).some(cls => cls.includes('active'));
  
        if (!disabled) {
          el.click();
        }
  
        const freeItemInCart = document.querySelector('#cart-items .free-item'); 
        if (!freeItemInCart) {
          showBanner(); 
        }
      });
  }
  
  function pageReady() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  }

  function waitFor(condition, timeout) {
    const stopTime = typeof timeout === 'number' ? timeout : 7000;
    let stop = false;

    window.setTimeout(function () {
      stop = true;
    }, stopTime);

    // eslint-disable-next-line no-undef
    return new Promise(function (resolve, reject) {
      (function _innerWaitFor() {
        const value = condition();

        if (stop) {
          reject();
        } else if (value) {
          resolve(value);
        } else {
          window.setTimeout(_innerWaitFor, 50);
        }
      })();
    });
  }
})(typeof unsafeWindow === 'undefined' ? window : unsafeWindow);



// old code 
//   (function(window) {
//   const testId = 'AB-026';
//   const variantId = 'variant-1';

//   waitFor(pageReady)
//     .then(runVariant)
//     .catch((err) => console.error(testId, err));

//   function runVariant(root) {
//     if (window.AB_026 === 1) return;

//     window.AB_026 = 1;
//     fetch(`${root}cart.js`)
//       .then(resp => resp.json())
//       .then(cart => {
//         const itemsInCart = cart.items && cart.items.length;
//         const freeItemInCart = cart.items && cart.items.some(item => item.id === 44480273088816);

//         if (freeItemInCart) {
//           showBanner();
//         }

//         if (itemsInCart && !freeItemInCart) {
//           enableSwitch();
//           showBanner();
//         }

//         observeCart();
//       })
//       .catch((err) => console.error(testId, err));

//     document.body.classList.add(testId);
//     console.log(`${testId}: ${variantId}`);
//   }

//   function showBanner() {
//     if (document.getElementById(`${testId}-banner`)) return;

//     waitFor(() => document.querySelector('.upcart-products-section'), 20000)
//       .then(prodsSection => {
//         const html = `
//           <div id="${testId}-banner">
//             <img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/MagneticBandsBlackANGLE_x120.png?v=1710123117">
//             <div class="${testId}-info">
//               <div class="${testId}-heading">
//                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.01305 15.7618L5.70254 10.6933C6.46856 8.39525 6.85156 7.24623 7.75782 7.03229C8.66408 6.81835 9.52051 7.67478 11.2334 9.38764L14.6124 12.7666C16.3252 14.4795 17.1817 15.3359 16.9677 16.2422C16.7538 17.1484 15.6048 17.5314 13.3067 18.2975L8.23822 19.987C5.47281 20.9088 4.0901 21.3697 3.36022 20.6398C2.63034 19.9099 3.09124 18.5272 4.01305 15.7618Z" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M12.2317 18.3462C12.2317 18.3462 11.4735 16.0651 11.4735 14.5554C11.4735 13.0456 12.2317 10.7645 12.2317 10.7645M8.06175 19.4835C8.06175 19.4835 7.42143 16.7316 7.30358 14.9345C7.10888 11.9652 8.06175 7.35272 8.06175 7.35272" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M14.5 10.0061L14.644 9.28614C14.7894 8.55924 15.3131 7.96597 16.0163 7.73155C16.7196 7.49714 17.2433 6.90387 17.3887 6.17697L17.5327 5.45703" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M17.5664 12.2536L17.7793 12.3765C18.4364 12.7558 19.2625 12.6722 19.8303 12.1688C20.3444 11.7129 21.0765 11.5973 21.7061 11.8725L21.9975 12" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M10.5299 3.00003C10.1924 3.55209 10.277 4.26347 10.7345 4.721L10.8324 4.81888C11.2255 5.21204 11.3705 5.78962 11.2096 6.32185" stroke="#FF7900" stroke-width="1.14286" stroke-linecap="round"/><path d="M13.5649 4.39629C13.766 4.19524 13.8665 4.09471 13.9828 4.05786C14.0811 4.02669 14.1866 4.02669 14.2849 4.05786C14.4012 4.09471 14.5017 4.19524 14.7028 4.39629C14.9038 4.59735 15.0043 4.69788 15.0412 4.81412C15.0724 4.91243 15.0724 5.01798 15.0412 5.1163C15.0043 5.23254 14.9038 5.33307 14.7028 5.53412C14.5017 5.73518 14.4012 5.83571 14.2849 5.87256C14.1866 5.90372 14.0811 5.90372 13.9828 5.87256C13.8665 5.83571 13.766 5.73518 13.5649 5.53412C13.3639 5.33307 13.2633 5.23254 13.2265 5.1163C13.1953 5.01798 13.1953 4.91243 13.2265 4.81412C13.2633 4.69788 13.3639 4.59735 13.5649 4.39629Z" fill="#FF7900"/><path d="M19.4643 7.46822C19.7097 7.22283 19.8324 7.10014 19.9708 7.04681C20.1328 6.9844 20.3122 6.9844 20.4742 7.04681C20.6126 7.10014 20.7353 7.22283 20.9807 7.46822C21.2261 7.71362 21.3488 7.83631 21.4021 7.97473C21.4645 8.1367 21.4645 8.31609 21.4021 8.47807C21.3488 8.61649 21.2261 8.73918 20.9807 8.98457C20.7353 9.22996 20.6126 9.35266 20.4742 9.40599C20.3122 9.4684 20.1328 9.4684 19.9708 9.40599C19.8324 9.35266 19.7097 9.22996 19.4643 8.98457C19.2189 8.73918 19.0962 8.61649 19.0429 8.47807C18.9805 8.31609 18.9805 8.1367 19.0429 7.97473C19.0962 7.83631 19.2189 7.71362 19.4643 7.46822Z" fill="#FF7900"/><path d="M6.91882 3.94082C7.12829 3.73135 7.4679 3.73135 7.67737 3.94082C7.88684 4.15029 7.88684 4.48991 7.67737 4.69938C7.4679 4.90885 7.12829 4.90885 6.91882 4.69938C6.70935 4.48991 6.70935 4.15029 6.91882 3.94082Z" fill="#FF7900"/><path d="M19.0594 15.3134C19.2689 15.1039 19.6085 15.1039 19.818 15.3134C20.0275 15.5228 20.0275 15.8624 19.818 16.0719C19.6085 16.2814 19.2689 16.2814 19.0594 16.0719C18.85 15.8624 18.85 15.5228 19.0594 15.3134Z" fill="#FF7900"/><path d="M17.501 9.74148C17.7104 9.53201 18.0501 9.53201 18.2595 9.74148C18.469 9.95095 18.469 10.2906 18.2595 10.5C18.0501 10.7095 17.7104 10.7095 17.501 10.5C17.2915 10.2906 17.2915 9.95095 17.501 9.74148Z" fill="#FF7900"/></svg>
//                 <p>Congratulations!</p>
//               </div>
//               <p class="${testId}-name">QuickRelease™ Safety Strap</p>
//               <div class="${testId}-sub"><p>FREE</p><p>&nbsp;gift valued at $20</p></div>
//             </div>
//           </div>`;
//         prodsSection.insertAdjacentHTML('beforebegin', html);
                
//       })
//       .catch(err => console.error(testId, err));
//   }

//   function observeCart() {
//     const config = {attributes: false, childList: true, subtree: true};
//     const observer = new MutationObserver(mutations => {
//       mutations.forEach(m => {
//         const spContainerAdded = m.addedNodes && Array.from(m.addedNodes).some(el => el.nodeType === 1 && el.matches('.upcart-addons'));

//         spContainerAdded && enableSwitch();
//       });
//     });

//     waitFor(() => document.getElementById('upCart'))
//       .then(upcartEl => observer.observe(upcartEl, config))
//       .catch((err) => console.error(testId, err));
//   }

//   function enableSwitch() {
//     waitFor(() => document.querySelector('#UpcartPopup .upcart-addons-toggle > div'), 20000)
//       .then(el => {
//         const disabled = Array.from(el.classList).some(cls => cls.includes('active'));

//         !disabled && el.click();
//         showBanner();
//       });
//   }

//   function pageReady() {
//     return window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
//   }

//   function waitFor(condition, timeout) {
//     const stopTime = typeof timeout === 'number' ? timeout : 7000;
//     let stop = false;

//     window.setTimeout(function() {
//       stop = true;
//     }, stopTime);

//     // eslint-disable-next-line no-undef
//     return new Promise(function(resolve, reject) {
//       (function _innerWaitFor() {
//         const value = condition();

//         if (stop) {
//           reject();
//         } else if (value) {
//           resolve(value);
//         } else {
//           window.setTimeout(_innerWaitFor, 50);
//         }
//       })();
//     });
//   }
// })(typeof unsafeWindow === 'undefined' ? window : unsafeWindow);